import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import HeroBanner from "./sections/HeroBanner";
import TheGlobalPulse from "./sections/TheGlobalPulse";
import TheImplementationRoadmap from "./sections/TheImplementationRoadmap";
import Feature from "./sections/Feature";
import Service from "./sections/Service";
import ImpactInMotion from "./sections/ImpactInMotion";
import Ready from "./sections/Ready";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <HeroBanner />
      <TheGlobalPulse />
      <TheImplementationRoadmap />
      <Feature />
      <Service />
      <ImpactInMotion />
      <Ready />
      <Footer />
    </div>;
}